var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Profile_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8384 7.40036C17.8384 10.3829 15.4077 12.8007 12.4092 12.8007C9.41081 12.8007 6.98011 10.3829 6.98011 7.40036C6.98011 4.41782 9.41081 2 12.4092 2C15.4077 2 17.8384 4.41782 17.8384 7.40036ZM17.0692 15.8434C18.7954 16.1815 19.9223 16.7331 20.4053 17.6228C20.7681 18.3171 20.7681 19.1437 20.4053 19.8381C19.9223 20.7278 18.8401 21.3149 17.0513 21.6174C16.2542 21.7729 15.4473 21.874 14.6363 21.9199C13.885 22 13.1337 22 12.3735 22H11.005C10.7188 21.9644 10.4415 21.9466 10.1732 21.9466C9.36219 21.9063 8.55514 21.8082 7.75825 21.653C6.03202 21.3327 4.90506 20.7633 4.42207 19.8737C4.23562 19.529 4.13732 19.144 4.13586 18.7527C4.13197 18.3589 4.22729 17.9705 4.41313 17.6228C4.88717 16.7331 6.01414 16.1548 7.75825 15.8434C8.55866 15.6915 9.36845 15.5934 10.1821 15.5498C11.6705 15.4338 13.1658 15.4338 14.6542 15.5498C15.4647 15.5955 16.2714 15.6936 17.0692 15.8434Z",
    fill: "#0D062D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3f9968523c43c65eb0a4129d7ed5d755.svg";
export { ForwardRef as ReactComponent };